// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__+W0BL","footerList":"Footer_footerList__Din8l"};